import { Result } from './model';
export var asAnyOf = function (sanitizers, expected) {
    return function (value, path) {
        if (sanitizers.length === 0) {
            return Result.ok(value);
        }
        for (var _i = 0, sanitizers_1 = sanitizers; _i < sanitizers_1.length; _i++) {
            var sanitizer = sanitizers_1[_i];
            var result = sanitizer(value, path);
            if (Result.isOk(result)) {
                return result;
            }
        }
        return Result.error([{ path: path, expected: expected }]);
    };
};
